import { Component } from '@angular/core';
import { ContextService } from '../../services/ctx.service';
import { FOOTER_URLS, SOCIAL_MEDIA_LINKS } from '../../../../assets/config/links';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  readonly year: string;
  readonly imgPath: string;

  item: any;
  footerUrls;
  environment: string;
  footerData;
  insurances: string[];
  insurances2: string[];
  others: string[];
  legals: string[];
  currentUrl: any;
  socialMediaLinks;

  constructor(
    private ctx: ContextService,
    private utils: UtilsService
  ) {
    this.year = new Date().getFullYear().toString();
    this.imgPath = 'assets/icons/';
    this.environment = this.ctx.environment;
    this.footerUrls = FOOTER_URLS[this.environment] || FOOTER_URLS.pro;
    this.footerData = this.getFooterLinks();
    this.socialMediaLinks = Object.keys(SOCIAL_MEDIA_LINKS)
  }

  navTo(id: string) {
    const url = this.footerUrls[id];
    this.utils.openExternalUrl(url);
  }

  private getFooterLinks() {
    return {

      legals: [
        {label: 'FOOTER.OTHER_PORTALS', id: 'other_portals'},
        { label: 'FOOTER.PRIVACY', id: 'privacy' },
        { label: 'FOOTER.COOKIE_POLICY', id: 'cookie_policy' },
        { label: 'FOOTER.NORMATIVE', id: 'normative' },
        { label: 'FOOTER.ACCESSIBILITY', id: 'accessibility' },
        { label: 'FOOTER.WARNINGS', id: 'warnings' },
        { label: 'FOOTER.ARCO_EXERCISE', id: 'ARCO'},
        { label: 'FOOTER.INTERES_INFORMATION', id: 'information_interest' },

      ],
    };
  }

  navToSocialMedia(index: number) {
    const url = Object.values(SOCIAL_MEDIA_LINKS)[index];
    this.utils.openExternalUrl(url);
  }


}
